import { useContext } from "react";
import "./FactorNoHabilitado.css";
import { useHistory } from "react-router";
import { hideModal } from "global/context/action/modal/modal";
import { logoutAuth } from "global/context/action/auth/login";
import { GlobalContext } from "global/context/Provider";
import { SegundoFactorContext } from "_+_Portal/_-_SegundoFactor/context/provider";

const FactorNoHabilitado = ({ mensaje }) => {
  const { modalDispatch, authDispatch, resetGlobalContext } =
    useContext(GlobalContext);
  const { resetSegundoFactorContext } = useContext(SegundoFactorContext);
  const history = useHistory();
  let config = localStorage.getItem("config");
  let opcResetContext = JSON.parse(config).opcResetContext;

  const cerrarModal = () => {
    hideModal()(modalDispatch);
    if (opcResetContext) {
      resetGlobalContext(0);
      resetSegundoFactorContext(0);
      history.push("/segundofactor");
    } else {
      logoutAuth()(authDispatch);
    }
  };

  return (
    <div className="FactorNoHabilitado-token">
      <div className="FactorNoHabilitado-token-body">
        <span className="FactorNoHabilitado-texto c-black rb18m noSeleccionable">
          {mensaje}
        </span>
        <div className="FactorNoHabilitado-token-btn">
          <div
            className="btn btn-FactorNoHabilitadoToken bgc-primary c-white rb18m noSeleccionable"
            onClick={cerrarModal}
          >
            Aceptar
          </div>
        </div>
      </div>
    </div>
  );
};

export default FactorNoHabilitado;
